/*
 * Confidential and Proprietary.
 * Do not distribute without 1-800-Flowers.com, Inc. consent.
 * Copyright 1-800-Flowers.com, Inc. 2019. All rights reserved.
 */

// libraries
import React from 'react';
import {
    shape, string, arrayOf, array, bool, object,
} from 'prop-types';
import { useQuery } from '@apollo/client';
import mbpLogger from 'mbp-logger';
import { withRouter } from 'react-router';

// redux, hooks, helpers
import { GRAPHQL_ENV } from '../../../gql';
import findContent from '../../../gql/queries/findContent';

// components
import CouponPageUI from './CouponPageUI';

const CouponPageBuilder = ({
    pageData,
}) => {
    const couponData = pageData;
    const contentType = 'promo_messaging';
    const findGetContentTypeData = {
        brand: couponData?.brand?.['domain-name'] || 'harryanddavid',
        contentType,
        GRAPHQL_ENV,
    };
    const COUPON_QUERY = findContent(findGetContentTypeData);
    const { loading, error, data } = useQuery(COUPON_QUERY);
    if (loading) {
        return null;
    }
    if (error) {
        mbpLogger.logError({
            appName: process.env.npm_package_name,
            query: COUPON_QUERY,
            jsError: error,
            component: 'CouponPageBuilder.js',
            message: `Failed to fetch content data for: content type ${contentType} on brand ${couponData.brand}`,
            env: GRAPHQL_ENV,
        });
    }
    if (!data) {
        mbpLogger.logWarning({
            appName: process.env.npm_package_name,
            query: COUPON_QUERY,
            component: 'CouponPageBuilder.js',
            message: 'No data returned for query',
            env: GRAPHQL_ENV,
        });
        return null;
    }

    // Because we modify data, we need to clone what comes from apollo
    couponData.data = { ...data };
    const tempPromos = couponData.data.findContent.content.entries.filter((coupon) => coupon.coupon_page.coupon_page && coupon.coupon_page.limited_time);
    tempPromos.sort((a, b) => parseFloat(a.coupon_page.ranking || 0) - parseFloat(b.coupon_page.ranking || 0)).reverse();
    const persistentPromos = couponData.data.findContent.content.entries.filter((coupon) => coupon.coupon_page.coupon_page && !coupon.coupon_page.limited_time);
    couponData.data.coupons = {
        tempPromos,
        persistentPromos,
    };

    return (
        <CouponPageUI pageData={couponData} />
    );
};

CouponPageBuilder.propTypes = {
    pageData: shape({
        header: string,
        footer: string,
        panelBackgroundColor: object.isRequired,
        title: string,
        uid: string,
        url: string,
        seo: shape({
            breadcrumbs: arrayOf(
                shape({
                    title: string,
                    href: string,
                }),
            ),
            keywords: string,
            meta_description: string,
            og: array,
            page_title: string,
            seo_searchable: bool,
        }),
        brand: shape({
            'domain-name': string,
        }),
    }).isRequired,
};

export default withRouter(CouponPageBuilder);
